import { ErrorBoundary } from '@sentry/react';
import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { AuthGuard } from 'src/guards/auth';
import DashboardLayout from 'src/layouts/dashboard';
import SentryErrorPage from 'src/pages/SentryErrorPage';

import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const KbReaderLayout = lazy(
  () => import('src/sections/knowledge-base/view/kb-reader-layout')
);
const KbReaderHomeView = lazy(
  () => import('src/sections/knowledge-base/view/kb-reader-home-view')
);
const KbReaderArticleView = lazy(
  () => import('src/sections/knowledge-base/view/kb-reader-article-view')
);
const KbReaderSearchView = lazy(
  () => import('src/sections/knowledge-base/view/kb-reader-search-view')
);
// NOTE: /help/c/:slug (category landing) is referenced by paths.help.category
// and category-card.tsx, but no dedicated view exists yet. Deferred to v2 —
// clicking a category card today will 404 until a KbReaderCategoryView is
// added.

// ----------------------------------------------------------------------

export const knowledgeBaseRoutes = [
  {
    path: 'help',
    element: (
      <ErrorBoundary fallback={<SentryErrorPage />}>
        <AuthGuard>
          <DashboardLayout>
            <Suspense fallback={<LoadingScreen />}>
              <Outlet />
            </Suspense>
          </DashboardLayout>
        </AuthGuard>
      </ErrorBoundary>
    ),
    children: [
      {
        element: <KbReaderLayout />,
        children: [
          { index: true, element: <KbReaderHomeView /> },
          { path: 'search', element: <KbReaderSearchView /> },
          { path: 'd/:slug', element: <KbReaderArticleView /> },
        ],
      },
    ],
  },
];
